import { render, staticRenderFns } from "./imgMessage.vue?vue&type=template&id=a7d5b298&scoped=true&"
import script from "./imgMessage.vue?vue&type=script&lang=js&"
export * from "./imgMessage.vue?vue&type=script&lang=js&"
import style0 from "./imgMessage.vue?vue&type=style&index=0&id=a7d5b298&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7d5b298",
  null
  
)

export default component.exports